var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{style:({zIndex: _vm.$vuetify.breakpoint.lgAndUp ? '1' : '6'}),attrs:{"light":"","clipped":"","right":"","app":""},model:{value:(_vm.showDrawer),callback:function ($$v) {_vm.showDrawer=$$v},expression:"showDrawer"}},[_c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }